import { useState } from "react";
import styled from "@emotion/styled";
import { E164Number } from "../../../../../api/src/types";
import PhoneField from "../../../components/forms/PhoneInputField";
import { QuestionWithRelations } from "../../../../../api/src/types";
import { validatePhoneWithRestriction } from "../utils/questionnaire";
import { useGetCurrentUserQuery } from "../../../api/users";
import { useUpsertAnswerMutation } from "../../../api/answers";
import { InputWrapper, ErrorWrapper } from "./SharedFormStyles";

export const PhoneFieldContainer = styled.div`
  flex: 1;
`;

interface PhoneInputFieldProps {
  question: QuestionWithRelations;
  documentId: string;
}

const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
  question,
  documentId,
}) => {
  const [phoneInput, setPhoneInput] = useState<string | null>(
    question.answers[0]?.valueTyped ?? null,
  );
  const [phoneError, setPhoneError] = useState<string | null>(null);

  const { data: user } = useGetCurrentUserQuery();
  const [
    upsertAnswer,
    {
      /*isLoading: isCreating,*/
      isError: isUpsertError,
      /*isSuccess: isCreateSuccess,*/
      /*isSuccess: isUpdateSuccess,*/
      reset: resetUpdateAnswer,
    },
  ] = useUpsertAnswerMutation();

  const hasAnswer = question.answers.length > 0;

  const handlePhoneChange = (value: E164Number | undefined) => {
    resetUpdateAnswer();

    setPhoneInput(value ?? "");
    if (!user) return;
    const payload = {
      questionId: question.id,
      userId: user.id,
      documentId,
      rootQuestionId: question.rootQuestionId ?? question.id,
      sectionId: question.parentQuestionnaireSectionId,
      serializeDebounceMs: 1000,
    };
    try {
      const error = validatePhoneWithRestriction(value ?? "", question);
      setPhoneError(error);

      if (value === undefined || value.length === 0) {
        if (hasAnswer) {
          void upsertAnswer({ ...payload, valueTyped: null });
        }
        return;
      } else if (!error) {
        void upsertAnswer({ ...payload, valueTyped: value });
        return;
      }
    } catch (err) {
      if (hasAnswer) {
        void upsertAnswer({ ...payload, valueTyped: null });
      }
      console.error("Phone validation error:", err);
      setPhoneError("Error processing phone number");
    }
  };

  //const isLoading = isCreating || isUpdating;
  const hasError = isUpsertError;
  /*const isSuccess =
    (isCreateSuccess || isUpdateSuccess) &&
    !hasError &&
    !isLoading &&
    !phoneError &&
    phoneInput !== "";
  */
  return (
    <>
      <InputWrapper>
        <PhoneFieldContainer>
          <PhoneField
            className="phone-input"
            value={phoneInput ?? ""}
            handlePhoneChange={handlePhoneChange}
            placeholder="Enter phone number"
            errorMessage={phoneError}
            required={question.isRequired}
          />
        </PhoneFieldContainer>
        {/* Commenting out the loader and success icon for now as per the request of the design team */}
        {/*
        {isLoading && (
          <IconContainer>
            <Loader spinnerOnly={true} size={isMobile ? 16 : 34} />
          </IconContainer>
        )}
        {isSuccess && (
          <IconContainer>
            <GreenTick size={isMobile ? IconSize.S : IconSize.XL} />
          </IconContainer>
        )}
        */}
      </InputWrapper>
      {hasError && (
        <ErrorWrapper>
          Error saving answer, please refresh the page and try again
        </ErrorWrapper>
      )}
    </>
  );
};

export default PhoneInputField;
